/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "DepositAdjustmentReason": {
                            "values": {
                              "DEPOSIT_ADJUSTMENT_REASON_UNSPECIFIED": 0,
                              "DEPOSIT_ADJUSTMENT_REASON_UNKNOWN": 1,
                              "DEPOSIT_ADJUSTMENT_REASON_AMOUNT_MISMATCH_ADJUSTMENT_NEGATIVE": 2,
                              "DEPOSIT_ADJUSTMENT_REASON_AMOUNT_MISMATCH_ADJUSTMENT_POSITIVE": 3,
                              "DEPOSIT_ADJUSTMENT_REASON_DUPLICATE_PRESENTMENT": 4,
                              "DEPOSIT_ADJUSTMENT_REASON_ERROR": 5,
                              "DEPOSIT_ADJUSTMENT_REASON_IMAGE_QUALITY": 6,
                              "DEPOSIT_ADJUSTMENT_REASON_INTERNAL_DUPLICATE_PRESENTMENT": 7,
                              "DEPOSIT_ADJUSTMENT_REASON_MICR_ERROR_UNABLE_TO_LOCATE": 8,
                              "DEPOSIT_ADJUSTMENT_REASON_MULTIPLE_OVERLAPPING_ITEMS": 12,
                              "DEPOSIT_ADJUSTMENT_REASON_NON_NEGOTIABLE": 9,
                              "DEPOSIT_ADJUSTMENT_REASON_OPERATOR_ERROR_MANUAL_REIMBURSEMENT": 10,
                              "DEPOSIT_ADJUSTMENT_REASON_PAYER_CLAIM": 11
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.DepositAdjustmentReason) {
  $root.addJSON(jsonData);
}

/**
 * next id: 13
 *
 * SOURCE DepositAdjustmentReason @ squareup/cash/gambit/api/v1/checkdeposit/deposit_adjustment_reason.proto at 8:1
 */
export const DepositAdjustmentReason = $root.lookupEnum('squareup.cash.gambit.api.v1.checkdeposit.DepositAdjustmentReason').values;